module.exports = __webpack_public_path__ + "img/3xiao.575ddd2e.png";